(function ($) {
    'use strict';

    $.extend(true, $.trumbowyg, {
        // Add some translations
        langs: {
            en: {
                fixups: 'Fixups',
                textDir: {
                    rtl: "Rtl",
                    ltr: "Ltr",
                }
            }
        },
        plugins: {
            textDir: {
                init: function (t) {
                    t.o.plugins.textDir = $.extend(true, {},
                        [],
                        t.o.plugins.textDir || {}
                    )

                    t.addBtnDef('rtl', {
                        title: t.lang.textDir.rtl,
                        ico: 'rtl',
                        fn: fn(t,'rtl'),
                    })
                    t.addBtnDef('ltr', {
                        title: t.lang.textDir.ltr,
                        ico: 'ltr',
                        fn: fn(t,'ltr'),
                    })

                },
                tagHandler: function (element, trumbowyg) {
                    if (element.hasAttribute('dir')) {
                        return [element.getAttribute('dir')]
                    }
                    return []
                },
                destroy: function (trumbowyg) {

                }
            },
            fixups: {
                init: function (trumbowyg) {
                    // trumbowyg.o.btnsDef.formatting.dropdown = ['p', 'h3']
                },
                tagHandler: function (element, trumbowyg) {
                    return [];
                },
                destroy: function (trumbowyg) {
                }
            }
        }
    })

    const P = element => {
        while (element.nodeName !== 'P' && !(element.classList && element.classList.contains('trumbowyg-editor'))) {
            element = element.parentElement
        }
        return element
    }

    const updateElementDirection = function (element, newValue) {
        if (!newValue || element.getAttribute('dir') === newValue) {
            element.removeAttribute('dir')
            return ''
        } else {
            element.setAttribute('dir', newValue)
            return newValue
        }
    }

    const fn = (t, dir) => {
        return () => {
            try {
                t.$ed.focus();
                t.saveRange();
                const range = t.range
                if (P(range.commonAncestorContainer).classList.contains('trumbowyg-editor')) {
                    let element = P(range.startContainer)
                    if (element.classList.contains('trumbowyg-editor')) {
                        element.innerHTML = '<p>' + element.innerHTML + '</p>'
                        element = element.childNodes[0]
                    }
                    // Update dir to align other elements with the first one.
                    dir = updateElementDirection(element, dir)
                    do {
                        element = element.nextElementSibling
                        if (!element || element === P(range.endContainer)) {
                            break
                        }
                        updateElementDirection(element, dir)
                    } while(true)
                } else {
                    updateElementDirection(P(range.commonAncestorContainer), dir)
                }
                t.restoreRange();
                t.syncCode();
                t.$c.trigger('tbwchange');
            } catch (e) {
                console.error(e)
                throw e
            }
        }
    }
})(jQuery);
